// extracted by mini-css-extract-plugin
export var fullWidthText = "fullWidthText-module--fullWidthText--91437";
export var fullWidthText__border = "fullWidthText-module--fullWidthText__border--3d3ec";
export var fullWidthText__cols = "fullWidthText-module--fullWidthText__cols--77f14";